<template>
    <div id="commissions-component">
        <b-modal v-model="showModal" id="modal-cotizador" hide-footer size="xl" centered scrollable :title="titleModal"
                 ref="modal-serv">

            <ticket-comission-quoter
                v-if="modalTicketQuoter"
                :quoter_id="quoting_id"
                :approved_ad="false"
                :commission="commission.provider">
            </ticket-comission-quoter>

        </b-modal>

        <main id="mainContent" class="padFixBoth">
            <div id="formCommissions" class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-sm-2 mb-3 mb-sm-0">
                            <select v-model="commission.provider" id="">
                                <option :value="0">Selecciona un proveedor</option>
                                <option :value="2">Agente</option>
                                <option :value="5">Promotores</option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="filter()">Obtener</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data">
                            <template #head(acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(nombre)="{item}">
                            <span v-if="item.tipo_per==1">
                                {{ item.nom_cont }} {{ item.paterno }} {{ item.materno }}
                            </span>
                                <span v-else> {{ item.nmComPerMoral }}</span>
                            </template>
                            <template #cell(estado)="{item}">
                        <span v-if="item.reledo">
                            {{ item.reledo.estado }}
                        </span>
                            </template>
                            <template #cell(ciudad)="{item}">
                         <span v-if="item.relcity">
                            {{ item.relcity.ciudad }}
                        </span>
                            </template>
                            <template #cell(paquete)="{item}">
                                {{ item.relpackage.paquete }}
                            </template>
                            <template #cell(total)="{item}">
                                {{ item.prima_total }}
                            </template>
                            <template #cell(comision_promotor)="{item}">
                                <span v-if="item.s_c_p===0" class="badge rounded-pill text-bg-danger">Pendiente</span>
                                <span v-if="item.s_c_p===1" class="badge rounded-pill text-bg-success">Pagada</span>
                            </template>
                            <template #cell(comision_agente)="{item}">
                                <span v-if="item.s_c_a===0" class="badge rounded-pill text-bg-danger">Pendiente</span>
                                <span v-if="item.s_c_a===1" class="badge rounded-pill text-bg-success">Pagada</span>
                            </template>
                            <template #cell(fecha)="{item}">
                                {{ formatDate(item.fecha) }}
                            </template>
                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="quoting_id=item.id;openModalsProviders('ticket_commission')">Subir
                                            Ticket Comisión</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {quotersService} from "../../Services/Quoters.service";

export default {
    name: "commissions",
    mixins: [myMixins],
    data() {
        return {
            isBusy: false,
            quoting_id: 0,
            commission: {
                provider: 0
            },
            params: {
                where: []
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'Nombre'},
                {key: 'estado'},
                {key: 'ciudad'},
                {key: 'paquete'},
                {key: 'total'},
                {key: 'fecha'},
                {key: 'comision_promotor'},
                {key: 'comision_agente'},
                {key: 'acciones'},
            ],
        }
    },
    methods: {
        async filter() {
            this.isBusy = true;
            let field_s_f = '';

            switch (this.commission.provider) {
                case 2:
                    field_s_f = 's_f_a'
                    break;
                case 5:
                    field_s_f = 's_f_p'
                    break;
            }

            this.params.where.push({
                field: field_s_f,
                operator: '=',
                value: 1
            }, {
                field: 'approved_at',
                operator: '!=',
                value: null
            });

            this.pagination = await quotersService.findQuotes(this.params);
            this.isBusy = false;
        },
    },
    mounted() {
    }
}
</script>

<style scoped>
#formCommissions .formSubmit {
    margin-top: 0;
}
</style>
